import 'bootstrap'; 
import 'jquery-lazy'; 
import './vendors/jquery-ui.js';
import './vendors/jquery.timepicker.js';
import './vendors/equalHeight.min.js';
import moment from "moment";  
import 'slick-carousel';

var _xhr = new XMLHttpRequest();

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irishรื
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
				// JavaScript to be fired on all pages
				$(".lazy").Lazy();
      },
      finalize: function() {

		  	var activeCalendarDate = $(".calendar-week").data("calendar-date");
	  		var month = null;
	  		var week = null;
	  		var week_start = null;
	  		var week_end = null;
	  		var events = null;
	  		var eventPopupData = {};

	  		$(".language-switcher").click(function() {
	  			$(this).find(".other-languages").toggleClass('open');
	  		});

	  		$(".map-button").click(function(){
	  			if ($($(this).data("text")).hasClass("open")) {
	  				$("#map-image").attr("src",$("#map-inactive").data("image"));
	  				$($(this).data("text")).hide();
	  				$($(this).data("text")).removeClass("open");
	  			} else {
	  				$("#map-image").attr("src",$(this).data("image"));
	  				$(".map-section__right").removeClass("open");
	  				$(".map-section__right").hide();
	  				$($(this).data("text")).show();
	  				$($(this).data("text")).addClass("open");
	  			}
	  			
	  			//$(".map-section__right").hide();
	  			//$($(this).data("text")).show();
	  		});

		  	$(".prev-week").click(function() {
		  		activeCalendarDate = moment(activeCalendarDate).subtract(1, 'week');
		  		changeCalendarWeek();
		  	});

		  	$(".next-week").click(function() {
		  		activeCalendarDate = moment(activeCalendarDate).add(1, 'week');
		  		changeCalendarWeek();
		  	});

		  	changeCalendarWeek();

		  	function changeCalendarWeek() {

					if (_xhr != null) { 
					    _xhr.abort();
					    _xhr = null;
					}

		  		$(".calendar-weekdays").html('<div class="calendar-body"><div class="loading"></div></div>');
		  		month = moment(activeCalendarDate).locale("sv").format('MMMM');
		  		week = moment(activeCalendarDate).format('WW');
		  		week_start = moment(activeCalendarDate).startOf('isoWeek');
		  		week_end = moment(activeCalendarDate).endOf('isoWeek');
		  		$(".calendar-week").html(week_start.format("D") + " - " + week_end.format("D") + " " + month + " (Vecka " + week + ")");
		  		renderWeekDaysHeader();

					_xhr = $.ajax({
						method: "GET",
					  dataType: "json",
					  data: { date: moment(activeCalendarDate).locale("sv").format('Y-MM-DD') },
					  url: "/wp-content/themes/kronocamping/ajax/getEvents.php",
					  success: function(eventList) {
					  	events = eventList;
					  	$(".calendar-weekdays").html('');
				  		renderEvents();
				  		calendarEntryClickEvents();
					  }
					});		  	
				}

		  	function renderWeekDaysHeader() {
		  		var weekDay = 0;
					for (var m = moment(week_start); m.isBefore(week_end); m.add(1, 'days')) {
					  weekDay++;
					  $(".calendar-weekdays-header").find('.calendar-day' + weekDay).html('<div class="cdh-btn">' + m.locale("sv").format("ddd D/M") + "</div>");
					}
		  	}

		  	function renderEvents() {
		  		
		  		// Add mobile events
		  		var weekDay = 0;
					for (var m = moment(week_start); m.isBefore(week_end); m.add(1, 'days')) {
					  weekDay++;

				  	var mobileEventsDay = document.createElement("div");
				  	$(mobileEventsDay).addClass("mobileEventsDay");
				  	if(weekDay == 1 && $(window).width() < 580) $(mobileEventsDay).css("display","block");

					  if(events[m.format("YYYY-MM-DD")]) {
							for (var event in events[m.format("YYYY-MM-DD")]) {
						  	var calendarRowEntry = document.createElement("div");
						  	$(calendarRowEntry).addClass("calendarEntry");
						  	$(calendarRowEntry).data("id", events[m.format("YYYY-MM-DD")][event].ID);
						  	$(calendarRowEntry).html(renderCalendarEntry(events[m.format("YYYY-MM-DD")][event]));
						  	$(calendarRowEntry).appendTo(mobileEventsDay);
							}
							$(mobileEventsDay).appendTo($(".calendar-weekdays-header").find('.calendar-day' + weekDay));
						} else {
							$(mobileEventsDay).html('<div class="text-center p-3 no-events-mobile"><b>Det finns ännu inga inlagda event på detta datum.</b></div>');
							$(mobileEventsDay).appendTo($(".calendar-weekdays-header").find('.calendar-day' + weekDay));
						}

						if(weekDay == 1 && $(window).width() < 580) $(".calendar-weekdays-header").find('.calendar-day' + weekDay).addClass("open");

					}

					// Add desktop events
		  		var failLSafe = 0;
		  		while(true) {
		  			failLSafe++;
						var calendarRow = document.createElement("div");
						$(calendarRow).attr("class", "calendar-row d-flex");

						if(events.length == 0) {
							$(".calendar-weekdays").html('<div class="calendar-body"><h4>Det finns inga event inlagda för denna vecka ännu.</h4></div>');
							break;
						}

		  			for (var m = moment(week_start); m.isBefore(week_end); m.add(1, 'days')) {
		  				var calendarRowEntry = document.createElement("div");
		  				$(calendarRowEntry).addClass("calendarEntry");
		  			  if(events[m.format("YYYY-MM-DD")]) {
		  			  		$(calendarRowEntry).html(renderCalendarEntry(events[m.format("YYYY-MM-DD")][0]));
		  			  		$(calendarRowEntry).data("id", events[m.format("YYYY-MM-DD")][0].ID);
			  			  	// Delete entry from events array
			  			  	events[m.format("YYYY-MM-DD")].splice(0, 1);
			  			  	// If all events for the day has been added remove day group from events array
			  			  	if(events[m.format("YYYY-MM-DD")].length == 0) {
			  			  		delete events[m.format("YYYY-MM-DD")];
			  			  	}
		  			  }
		  				$(calendarRowEntry).appendTo(calendarRow);
		  			}

		  			var eventsLeft = 0;
						for (var event in events) {
								eventsLeft++;
						}

		  			$(calendarRow).appendTo(".calendar-weekdays");

		  			if(eventsLeft == 0 || failLSafe > 999) {
		  				break;
		  			}
		  		}

					$('.cdh-btn').click(function() {
						$(this).parent().toggleClass("open");
						$(this).next().slideToggle();
					});

		  	}

				function calendarEntryClickEvents()  {
			  	$(".calendarEntry").click(function() {
			  		if($(this).text() != "") {
				  		$(".modal-text-wrapper").html(eventPopupData[$(this).data("id")]);
				  		$('#calendarPopup').modal();
			  	}
			  	});
				}

		  	function renderCalendarEntry(data) {
		  		var popupHTML  = "";
		  				popupHTML += "<h2>" + data.title + "</h2>";
		  				popupHTML += "<p>" + data.text + "</p>";
		  		if(data.booking) popupHTML += '<a href="' + data.booking + '"><button class="btn btn-yellow">Boka nu</button></a>';
		  		if(data.read_more) popupHTML += '<a href="' + data.read_more + '"><button class="btn btn btn-blue-transparent">Läs mer</button></a>';
		  		eventPopupData[data.ID] = popupHTML;
	  			var calendarEntryContent = document.createElement("div");
	  			var startTime = data.start_time;
	  			var endTime = data.end_time;
	  			if(data.event_all_day) {
	  				startTime = "Hela dagen";
	  			} else if(endTime != null) {
	  				startTime = startTime + " - " + endTime;
	  			}
		  		$(calendarEntryContent).append('<div class="calendarEntryTime">'+ startTime +'</div>');
		  		$(calendarEntryContent).append('<div class="calendarEntryName d-flex"><div class="calendarEntryMarker" style="background-color: ' + data.category + ';"></div><div>'+ data.title +'</div></div>');
		  		return $(calendarEntryContent).html();
		  	}

				$('#sliderInMobile').slick({
					dots: true,
					infinite: true,
					arrows: false,
					speed: 1000,
					centerMode: false, 
					adaptiveHeight: true,
					responsive: [
					    {
					      breakpoint: 9999,
					      settings: "unslick"
					    },
					    {
					      breakpoint: 640,
					      settings: {
					        slidesToShow: 1,
					        slidesToScroll: 1
					      }
					    },
					    // You can unslick at a given breakpoint now by adding:
					    // settings: "unslick"
					    // instead of a settings object
					  ]
				});

      	$(".mobile-menu-btn").click(function() {
      		$("body").toggleClass("mobile-menu-active");
      		$(this).find('.ham').toggleClass("active");
      		$(".menu-list-wrapper").slideToggle();
      	});

      	$(".menu-list-wrapper .menu-item-has-children").click(function() {
      		$(this).toggleClass("open");
      		$(this).find("> ul").slideToggle();
      	});

      	$(".sidemenu .menu-item-has-children").click(function() {
      		$(this).toggleClass("open");
      		$(this).find(".level-2").slideToggle("fast");
      	});

      	$(".info-list__head").click(function(){
      		$(this).parents(".info-list__item").find(".info-list__expand").slideToggle("fast");
      		$(this).parents(".info-list__item").toggleClass("info-list__item--open");
      	});

		$(".faq-accordion__head").click(function(){
			$(this).parents(".faq-accordion__item").find(".faq-accordion__expand").slideToggle("fast");
			$(this).parents(".faq-accordion__item").toggleClass("faq-accordion__item--open");
		});

      	var bookingUrl = $("#booking-form-submit").attr("href");

      	$(".search-widget input, .search-widget select").change(function() {

      		var url = bookingUrl;

      		if(!bookingUrl.includes("?")) {
      			url += "?";
      		}

      		if($(this).parents(".search-widget").find("input[name=from]").val() != "") {
      			var from = $(this).parents(".search-widget").find("input[name=from]").val();
      			from = from.split("-");
      			url += "&from=" + from[2] + "-" + from[1] + "-" + from[0];
      		}

      		if($(this).parents(".search-widget").find("input[name=to]").val() != "") {
      			var to = $(this).parents(".search-widget").find("input[name=to]").val();
      			to = to.split("-");
      			url += "&to=" + to[2] + "-" + to[1] + "-" + to[0];
      		} 


      		$("#booking-form-submit").attr("href", url);
      		$("#booking-form-submit-mobile").attr("href", url);
      	});
	 
				// SEO Content
				$('.btn-readmore').click(function() {
					$(this).remove();
					$('.readmore-text').fadeIn('slow'); 
					return false;
				});

				// Date Picker
				$.datepicker.regional['sv'] = {
				  closeText: 'Stäng',
					prevText: '< Föregående',
					nextText: 'Nästa >',
					currentText: 'Nu',
					monthNames: ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
			    monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
					dayNamesShort: ['Sön','Mån','Tis','Ons','Tor','Fre','Lör'],
					dayNames: ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
					dayNamesMin: ['Sö','Må','Ti','On','To','Fr','Lö'],
					weekHeader: 'Не',
					dateFormat: 'yy-mm-dd',
					firstDay: 1,
					isRTL: false,
					showMonthAfterYear: false,
					yearSuffix: ''
				};

				if(!$("body").hasClass("page-template-langneutral")) {
					$.datepicker.setDefaults($.datepicker.regional['sv']);
				}

				$('.datepicker').datepicker({
					dateFormat: 'yy-mm-dd'
				});

				$('.datepicker').on('focus',function(){
					if($(window).width < 768) {
						$(this).trigger('blur');
					}
				});

				// Timepicker Source : https://timepicker.co/
				$('input.timepicker').timepicker({
					timeFormat: 'HH:mm',
					interval: 30,
					minTime: '05:00:00',
					maxTime: '19:00:00',
					dynamic: false,
					dropdown: true,
					scrollbar: true
				});

				$('.timepicker').on('focus',function(){
					if($(window).width < 768) {
						$(this).trigger('blur');
					}
				});


				$('#images-slider').slick({
					lazyLoad: 'ondemand',
					dots: true,
					infinite: true,
					speed: 1000,
					fade: true,
					cssEase: 'linear',
					arrows: true, 
					autoplay: true,
					centerMode: true, 
					variableWidth: false,
					autoplaySpeed: 3000, 
				});

				$('#camping-slider').slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: true,
					centerMode: false,
					infinite: true,
					variableWidth: false,
					responsive: [
						{	
							breakpoint: 992,
							settings: {
								slidesToShow: 2, 
								slidesToScroll: 1,
								variableWidth: true,
							}
						},
					]
				});

				$('.events-slider').slick({
					slidesToShow: 2, 
					slidesToScroll: 1,
					arrows: true,
					centerMode: false,
					infinite: true,
					variableWidth: true,
					responsive: [
						{	
							breakpoint: 992,
							settings: {
								slidesToShow: 1, 
								slidesToScroll: 1,
							}
						},
					]
				});

		  	// Responsive tables
		  	if($(window).width() < 768) {
			  	$(".wp-block-table").each(function() {
			  		var boxes = {};
			  		var listValues = [];
			  		var listKeys = [];
			  		var columns = $(this).find("tr:first-child").children().length;
			  		var table = this;
			  		if(columns > 2) {
			  			// Get list keys from header row
			  			$(this).find("tr:first-child").children().each(function(index) {
			  				if(index==0) return; // exclude first table column
			  				listKeys.push($(this).text());
			  			});
			  			// Get columns
			  			$(this).find("tr").each(function(index) {
			  				if(index==0) return; // exclude heading row
			  				listValues = [];
			  				$(this).children().each(function(index) {
			  					if(index==0) return; // exclude first column
			  					listValues.push($(this).text());
			  				});
			  				boxes[$(this).find("td:first-child").text()] = listValues;
			  			});
			  		//	console.log(boxes);
			  			// Render responsive boxes
							for (var box in boxes) {
							  if (boxes.hasOwnProperty(box)) {
							    var wrapper = $("<div></div>").addClass("mobileDropdownBox");
							    var content = $("<div></div>").addClass("mobileDropdownBox-content");
							    $(wrapper).append('<div class="mobileDropdownBox-header">' + box + '</div>');
									$(wrapper).find('.mobileDropdownBox-header').click(function() {
										$(this).parent().toggleClass('open');
										$(this).parent().find('.mobileDropdownBox-content').slideToggle('slow'); 
									});
							    $(boxes[box]).each(function(key, value) {
							    	var html = "";
							    	html += '<div class="row">';
							    	html += '<div class="col">' + listKeys[key] +  '</div>';
							    	html += '<div class="col">' + value + '</div>';
							    	html += '</div>';
							    	$(content).append(html);
							    });
							    $(wrapper).append(content);
							    $(table).before(wrapper);
							  }
							}
							$(table).remove();
			  		}
			  	});
				}

				//page konferens script

				//konferens-card height and expand content
				$(document).on('click', '.konferens-card__expand-btn', function () {
					var $card = $(this).closest('.konferens-card'); // Parent .konferens-card
					var $expandContent = $card.find('.konferens-card__expand-content');
				
					// Check if content is currently expanded
					if (!$expandContent.is(":visible")) {
						// Only apply height logic if window width is greater than or equal to 768px (desktop)
						if ($(window).width() >= 768) {
							// Save current height before expanding
							var originalHeight = $card.outerHeight();
							$card.data('originalHeight', originalHeight);
				
							// Lock current height to prevent shrinking before expanding
							$card.css({
								'height': originalHeight + 'px', // Apply height only to the current card
								'overflow': 'hidden'
							});
				
							// Use requestAnimationFrame to ensure CSS changes happen before animation starts
							requestAnimationFrame(function() {
								// Expand the content
								$expandContent.slideDown({
									start: function () {
										// Set height to 'auto' after the animation starts
										$card.css({
											'height': 'auto', // Allow content to expand naturally
											'min-height': $card.data('originalHeight') + 'px' // Set min-height for desktop
										});
									}
								});
							});
						} else {
							// For mobile/tablet, just expand the content without locking height
							$expandContent.slideDown();
						}
				
						// Update button states
						$(this).find('.konferens-card__expand-btn--open').removeClass('d-flex');
						$(this).find('.konferens-card__expand-btn--close').addClass('d-flex');
					} else {
						// Collapse content and ensure min-height is respected before animation
						var originalHeight = $card.data('originalHeight');
						if ($(window).width() >= 768) {
							$card.css('min-height', originalHeight + 'px'); // Set min-height before collapsing on desktop
						}
				
						$(this).find('.konferens-card__expand-btn--open').addClass('d-flex');
						$(this).find('.konferens-card__expand-btn--close').removeClass('d-flex');
				
						// Collapse the content and restore original height
						$expandContent.slideUp(function () {
							if (originalHeight) {
								$card.css({
									'height': $(window).width() >= 768 ? originalHeight + 'px' : '', // Reset height for desktop
									'min-height': '' // Reset min-height after collapsing
								});
							}
						});
					}
				});
				
			
				// Function to set equal heights within the same wrapper
				function setEqualHeightInWrapper(wrapper, child) {
					$(wrapper).each(function () {
						var maxHeight = 0;
			
						// Reset heights
						var $children = $(this).find(child);
						$children.css('height', 'auto');
			
						// Find the tallest child
						$children.each(function () {
							var currentHeight = $(this).outerHeight(true);
							if (currentHeight > maxHeight) {
								maxHeight = currentHeight;
							}
						});
			
						// Apply the tallest height
						$children.height(maxHeight);
					});
				}
			
				$(window).on('load', function () {
					// Apply equal heights for .konferens-card inside .konferens-block
					if ($(window).width() >= 768) {
						// Apply equal heights for .konferens-card inside .konferens-block
						setEqualHeightInWrapper('.konferens-block', '.konferens-card');
					}
				  
					// Apply equal heights for .quote__item inside .quote__slideshow
					setEqualHeightInWrapper('.quote__slideshow', '.quote__item--inner');
				});
				  
				// Recalculate heights on window resize
				$(window).on('resize', function () {
					if ($(window).width() >= 768) {
						setEqualHeightInWrapper('.konferens-block', '.konferens-card');
					}
					setEqualHeightInWrapper('.quote__slideshow', '.quote__item--inner');
				});

				if ($(".conference-cards-slider > .konferens-card-col").length > 3) {

					let slidesToShow = 3;
					if($(window).width() < 768) {
						slidesToShow = 1;
					} else if($(window).width() < 1200) {
						slidesToShow = 2;
					}

					$('.conference-cards-slider').slick({
						slidesToShow: slidesToShow,
						slidesToScroll: 1,
						infinite: false,
						arrows: true,
						appendArrows: $("#conference-cards-slider-pager"),
						responsive: [
							{
								breakpoint: 768,
								settings: {
									centerMode: true
								}
							}
						]
					});
				}				

				//slider for images inside konferens-card
				$('.konferens-card__images').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					arrows: true,
				});

				// Function to initialize a slider and its slide count
				function initializeSlider(sliderSelector, slideCountSelector, options) {
					$(sliderSelector).each(function (index, slider) {
						var $slider = $(slider); // Current slider
						var $slideCount = $slider.closest('.slider-container').find(slideCountSelector); // Find related slide count element
			
						// Initialize the slider
						$slider.slick(options);
			
						// Function to update the slide count
						function updateSlideCount(currentIndex) {
							var currentSlide = currentIndex + 1; // Slick uses zero-based index

							var totalSlides = $slider.slick('getSlick').slideCount;
							$slideCount.text(`${currentSlide} / ${totalSlides}`);

							// Check if it's the last slide
							if (currentSlide === totalSlides) {
								$slideCount.parents('.slider-container').addClass('current-last');
							} else {
								$slideCount.parents('.slider-container').removeClass('current-last');
							}
						}
			
						// Set initial slide count after initialization
						$slider.on('init', function (event, slick) {
							updateSlideCount(slick.currentSlide);
						});
			
						// Update slide count on slide change
						$slider.on('afterChange', function (event, slick, currentSlide) {
							updateSlideCount(currentSlide);
						});
					});
				}
			
				// Initialize each slider with specific options
				initializeSlider('.text-slideshow__slideshow', '.text-slideshow__slidecount', {
					slidesToShow: 1.5,
					slidesToScroll: 1,
					infinite: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1.2,
								slidesToScroll: 1,
							},
						}
					],
				});
			
				initializeSlider('.activity__slideshow', '.activity__slidecount', {
					slidesToShow: 1.5,
					slidesToScroll: 1,
					infinite: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1.2,
								slidesToScroll: 1,
							},
						}
					],
				});
			
				initializeSlider('.quote__slideshow', '.quote__slidecount', {
					dots: false,
					infinite: false,
					slidesToShow: 6,
					slidesToScroll: 1,
					adaptiveHeight: false,
					responsive: [
						{
							breakpoint: 991,
							settings: {
								slidesToShow: 3.5,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 2.5,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1.5,
								slidesToScroll: 1,
							},
						},
					],
				});

				//set height for quote__item

				/*var quotemaxHeight = 0;

				$('.quote__slideshow .quote__item').each(function() {
					var quoteorgHeight = $(this).outerHeight(true);
					if (quoteorgHeight > quotemaxHeight) {
						quotemaxHeight = quoteorgHeight;
					}
				});

				$('.quote__slideshow .quote__item').each(function() {
					$(this).height(quotemaxHeight);
				});*/

      }
    },
    'page_template_page_faq': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

      	function showHideFaqs() {
      		$(".faq-group").hide();
      		$(".filter.active").each(function() {
      			if($(this).data("filter") == '') {
      				$(".faq-group").show();
      			} else {
      				$(".faq-group.filter-" + $(this).data("filter")).show();
      			}
      		});
      	}

      	$(".filter").click(function() {
      		
      		if($(this).data("filter") == '') {
      			$(".filter").removeClass("active");
      			$(this).addClass("active");
      		} else {
      			$(".filter[data-filter='']").removeClass("active");
      			$(this).toggleClass("active");
      			if($(".filter.active").length == 0) {
      				$(".filter[data-filter='']").addClass("active");
      			}
      		}

      		showHideFaqs();
      	});

      }
    },
    'page_template_blogs': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

      	$("[data-filter]").click(function(e) {
      		$(".blog-filter-items .list-item").addClass("d-none").removeClass("d-flex");
      		$("[data-filter]").addClass("btn-blue-transparent");
      		$(this).removeClass("btn-blue-transparent");
      		if($(this).data("filter") != "") {
      			$(".c-" + $(this).data("filter")).removeClass("d-none").addClass("d-flex");
      		} else {
      			$(".blog-filter-items .list-item").removeClass("d-none").addClass("d-flex");
      		}
      		return false;
      	});

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
